import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

// const API_BASE_URL: string = "http://localhost:9002";
const API_BASE_URL: string = "https://adminapi.gk360app.com";

interface ApiServiceProps {
  method: string;
  endpoint: string;
  headers?: Record<string, string>;
  data?: any;
  params?: Record<string, any>; // ✅ supports query params
}

const ApiService = async ({
  method,
  endpoint,
  headers = {},
  data,
  params,
}: ApiServiceProps): Promise<any> => {
  const token = Cookies.get("admin_authToken");

  const axiosConfig: AxiosRequestConfig = {
    method,
    withCredentials: true,
    url: `${API_BASE_URL}/${endpoint}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    data,
    params,
  };

  const api = axios.create();

  api.interceptors.response.use(
    (response) => response.data,
    (error) => {
      console.error("API Response Error:", error);
      throw error;
    }
  );

  try {
    const response = await api(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Send question to Telegram as a poll
 */
export const sendQuestionToTelegram = async (questionData: {
  questionText: string;
  options: Array<{ optionText: string; isCorrect: boolean }>;
  description: string;
}): Promise<any> => {
  // Find the index of the correct option
  const correctOptionIndex = questionData.options.findIndex(
    (option) => option.isCorrect === true
  );

  if (correctOptionIndex === -1) {
    throw new Error("No correct option found in the question");
  }

  // Extract option texts
  const optionTexts = questionData.options.map((option) => option.optionText);

  // Prepare payload for Telegram API
  const payload = {
    chat_id: "@gk360app", //"@swarasoftware",
    question: questionData.questionText,
    options: optionTexts,
    type: "quiz",
    correct_option_id: correctOptionIndex,
    explanation: "", //questionData.description || "",
  };

  // Call Telegram API directly (not through our API service since it's external)
  const TELEGRAM_BOT_TOKEN = "8496878478:AAEdf8OVY6L4oM0fucnRnUxaQ8xyq57qsdk";
  const TELEGRAM_API_URL = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendPoll`;

  try {
    const response = await axios.post(TELEGRAM_API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Telegram API Error:", error);
    throw error;
  }
};

export default ApiService;
